/**
 * Phone verification banner component.
 */

import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useAuth } from '@/contexts/AuthContext';
import PhoneVerificationModal from '@/components/modals/PhoneVerificationModal';

export default function PhoneVerificationBanner() {
  const { user } = useAuth();
  const [showModal, setShowModal] = React.useState(false);

  if (user?.phone_verified) {
    return null;
  }

  return (
    <>
      <Alert variant="warning" dismissible className="mb-4">
        <i className="fas fa-exclamation-triangle me-2"></i>
        Your phone number is not verified.{' '}
        <strong>Orders will remain in Pending state until verified.</strong>
        <br />
        <small className="text-muted">Please verify your phone number to place orders.</small>
        <Button
          variant="warning"
          size="sm"
          className="ms-2"
          onClick={() => setShowModal(true)}
        >
          Verify Phone Number
        </Button>
      </Alert>
      <PhoneVerificationModal show={showModal} onHide={() => setShowModal(false)} />
    </>
  );
}
